"use client";

import { useClientTranslation } from "@/app/i18n/client";
import Image from "next/image";
import { useTranslation } from "@/hooks/translationContext";

interface Props {
  count: number;
  onClick: () => void;
}

export default function SeeMoreButton({ onClick, count = 0 }: Props) {
  const { t } = useTranslation();

  return (
    <button
      onClick={() => onClick()}
      className="w-full justify-between rounded-2xl p-2 bg-white text-sm font-bold text-primary flex gap-1 items-center"
    >
      <Image
        loader={({ src }) => src}
        sizes="24px"
        unoptimized
        src="/scroll-down.webp"
        alt={t("homepage-scroll-down-alt")}
        width={24}
        height={24}
        style={{
          maxWidth: "100%",
        }}
      />

      <span>
        {" "}
        {t("list-review-button-text", {
          count: count,
          defaultValue: `${count} işletmeyi görüntüle`,
        })}
      </span>

      <Image
        loader={({ src }) => src}
        src="/scroll-down.webp"
        unoptimized
        loading="lazy"
        sizes="24px"
        alt={t("homepage-scroll-down-alt")}
        width={24}
        height={24}
        style={{
          maxWidth: "100%",
        }}
      />
    </button>
  );
}
